import * as _ from "lodash";
import ReactDOM from "react-dom";
import React from "react";
import * as SmartDrawings from "../../smartDrawings";
import BcfCheckbox from "./bcfCheckbox";
import BcfSnapshot from './bcfSnapshot';

export class BcfPanelData extends Autodesk.Viewing.UI.DockingPanel {

    private readonly viewer: Autodesk.Viewing.GuiViewer3D;

    private readonly contentDiv: HTMLDivElement;
    private readonly reactNode;

    private snapshot: BcfSnapshot;
    private readonly bcf: SmartDrawings.BcfInfo;
    private extGotoViewpoint: (markupIndex: number, snapshotIndex: number) => void;
    private extGotoHome: () => void;
    private extUseGhosting: (use: boolean) => void;

    private extPrevMarkup: () => void;
    private extNextMarkup: () => void;
    private extPrevSnapshot: () => void;
    private extNextSnapshot: () => void;

    constructor(viewer: Autodesk.Viewing.GuiViewer3D,
        bcf: SmartDrawings.BcfInfo,
        gotoViewpoint: (markupIndex: number, snapshotIndex: number) => void,
        gotoHome: () => void,
        useGhosting: (use: boolean) => void,
        prevMarkup: () => void,
        nextMarkup: () => void,
        prevSnapshot: () => void,
        nextSnapshot: () => void) {
        super((viewer.container as HTMLElement), "SmartDrawings-Panel-Bcf-Data", "BCF", null);
        this.viewer = viewer;

        this.container.classList.add("bcf-data-panel");

        this.contentDiv = document.createElement("div");
        this.contentDiv.classList.add("content");
        this.container.appendChild(this.contentDiv);

        this.contentDiv.setAttribute("style",
            "display: flex; flex-direction: column; padding: 20px; overflow-y: auto; height: calc(100% - 109px);" +
            "background-color: rgba(34, 34, 34, 0.9);");

        this.bcf = bcf;
        this.extGotoViewpoint = gotoViewpoint;
        this.extGotoHome = gotoHome;
        this.extUseGhosting = useGhosting;

        this.extPrevMarkup = prevMarkup;
        this.extNextMarkup = nextMarkup;
        this.extPrevSnapshot = prevSnapshot;
        this.extNextSnapshot = nextSnapshot;

        ReactDOM.unmountComponentAtNode(this.contentDiv);

        this.setMarkup = this.setMarkup.bind(this);

        const markup = this.bcf.Markups[0];
        const viewpoint = markup.Viewpoints[0];

        this.reactNode = ReactDOM.render(<React.Fragment>
            <div style={{ marginBottom: "10px" }}>
                <BcfCheckbox name="Ghost hidden items" onClick={checked => this.extUseGhosting(checked)} />
            </div>
            
            <BcfSnapshot ref={(ref) => this.snapshot = ref}
                title={markup.Topic.Title}
                comments={markup.Comment}
                data={viewpoint.SnapshotContents}
                description={markup.Topic.Description}
                lastMarkup={0} lastSnapshot={0}
                prevMarkup={prevMarkup}
                nextMarkup={nextMarkup}
                prevSnapshot={prevSnapshot}
                nextSnapshot={nextSnapshot}
                markupCount={bcf.Markups.length}
                snapshotCount={markup.Viewpoints.length}            />
            </React.Fragment>
            , this.contentDiv);
    }

    setVisible(show: boolean) {
        super.setVisible(show);

        if (show) {
            this.container.classList.remove("d-none");
            this.resizeToContent(null);
            return;
        }

        this.container.classList.add("d-none");
    }

    setMarkup(markupIndex: number, snapshotIndex: number) {
        const markup = this.bcf.Markups[markupIndex];
        const snapshotContent = (markup.Viewpoints ?? []).length === 0
            ? null
            : markup.Viewpoints[snapshotIndex].SnapshotContents; 

        this.snapshot.setState({
            title: markup.Topic.Title,
            description: markup.Topic.Description ?? "",
            comments: markup.Comment,
            data: snapshotContent,
            lastMarkup: markupIndex,
            lastSnapshot: snapshotIndex,
            snapshotCount: (markup.Viewpoints ?? []).length
        });
    }
}